import { render, staticRenderFns } from "./StaffDetails.vue?vue&type=template&id=680cc028&scoped=true"
import script from "./StaffDetails.vue?vue&type=script&lang=js"
export * from "./StaffDetails.vue?vue&type=script&lang=js"
import style0 from "./StaffDetails.vue?vue&type=style&index=0&id=680cc028&prod&scoped=true&lang=css"
import style1 from "./StaffDetails.vue?vue&type=style&index=1&id=680cc028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680cc028",
  null
  
)

export default component.exports